import { FormItem } from 'sections/EditForm';

const exampleData = {
  technical_features: 'Prodotto',
  technical_data_en: '',
  technical_data_it: '',
};

const formData: FormItem[] = [
  {
    name: 'technical_features',
    value: exampleData.technical_features,
    label: 'Technical Features',
  },
  {
    name: 'technical_data_it',
    value: exampleData.technical_data_it,
    label: 'Technical Data',
    flag: 'it',
  },
  {
    name: 'technical_data_en',
    value: exampleData.technical_data_en,
    flag: 'en',
  },
];

export { formData };
